import { Avatar, TableColumnsType } from "antd";
import moment from "moment";
import { FilePdfOutlined } from "@ant-design/icons";

import { ResponseOfferTableType } from "../../models";

export const offerResponeColumns = (
  searchOffer: string,
  exportPdf: (id: string) => void
) => {
  const columns: TableColumnsType<ResponseOfferTableType> = [
    {
      title: "NASLOV",
      dataIndex: "name",
      render: (text) => <a className="text-primary cursor-default">{text}</a>,
      filteredValue: [searchOffer],
      onFilter: (value, record) => {
        return record?.name.toLowerCase().includes(searchOffer?.toLowerCase());
      },
    },
    {
      title: "Naziv klijenta",
      dataIndex: "client",
    },
    {
      title: <div className="text-center">Broj kreiranih ponuda</div>,
      width: 140,
      responsive: ["md"],
      render: (record) => (
        <div className="text-center">
          <Avatar className="bg-offer-blue font-bold" size="small">
            {record.offerResponse.length}
          </Avatar>
        </div>
      ),
    },
    {
      title: <div className="text-center">Izvezi u PDF</div>,
      responsive: ["sm"],
      width: 120,
      render: (record) => (
        <div className="text-center mt-[2px]">
          <FilePdfOutlined
            className="text-2xl"
            onClick={() => exportPdf(record.key)}
          />
        </div>
      ),
    },

    {
      title: "Datum zadnje izmjene",
      dataIndex: "lastUpdate",
      responsive: ["lg"],
      width: 190,
      sorter: (a, b) => moment(a.lastUpdate).diff(moment(b.lastUpdate)),
    },
  ];

  return columns;
};
